import React from "react";
import { locationIcon } from "../../locationIcon";
import { FoodItem, Restaurant, Type } from "../../types";
import "./cardStyle.css";
import { useNavigate } from "react-router-dom";

const Card = ({
  food,
  restaurant,
}: {
  food: FoodItem;
  restaurant: Restaurant;
}) => {
  const navigate = useNavigate();
  return (
    <div className="cardWrap" onClick={() => navigate(`/food/${food.id}`)}>
      <div className="header">
        <div>{food.name}</div>
        <div className="typeWrap">
          <div
            style={{ background: food.type === Type.Veg ? "green" : "red" }}
            className="dot"
          />
          {food.type}
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div className="imgWrap">
          <img src={food.image} alt={food.name} className="image" loading="lazy"/>
        </div>
        <div className="right">
          {food.description && <div className="desc">{food.description}</div>}

          {restaurant.name && (
            <div className="restname">
              <span className="by">by </span>
              {restaurant.website ? (
                <a
                  href={restaurant.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {restaurant.name}
                </a>
              ) : (
                restaurant.name
              )}
            </div>
          )}

          <div>
            {food.labels.map((label) => (
              <span className="label">{label}</span>
            ))}
          </div>

          <div className="loc">
            <span>{locationIcon}</span>
            {restaurant.location.url ? (
              <a
                href={restaurant.location.url}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                {restaurant.location.place}
              </a>
            ) : (
              restaurant.location.place
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
